import { useSelector } from 'react-redux';

export const usePermissionCustomHook = (permissionName) => {
  const myPermissions = useSelector(
    (state) => state?.myPermissions?.permissions,
  );
  return hasPermission(permissionName, myPermissions);
};

export const hasPermission = (permissionName, myPermissions) => {
  const permissionsArray = Array.isArray(myPermissions) ? myPermissions : [];

  if (!permissionName) return true;

  // single permission (existing support)
  if (typeof permissionName === 'string') {
    return permissionsArray.includes(permissionName);
  }

  // multiple permissions (new support)
  if (Array.isArray(permissionName)) {
    return permissionName.every((perm) => permissionsArray.includes(perm));
  }

  return false;
};
